module.exports = "https://la-static.vkplay.ru/promo/universal/img/pic.b0f6cd5d.png";